var ezdia;
(function (ezdia) {
    var listTemplate = function (context) {
        var editable = context.editable, rows = context.rows, name = context.name, isRearrange = context.rearrange;
        var listItems = '';
        var rearrange = '';
        if (editable) {
            listItems = (rows || [])
                .map(function (obj) {
                var value = obj.value, cls = obj.cls;
                return "<li class=\"input-list input-list-old clearfix\" data-row=\"groupFields\">\n          <i class=\"fa fa-pencil-square\" data-btn=\"edit\" title=\"Click to edit\"></i> " + value + "\n          <input class=\"form-control " + cls + "\" type=\"hidden\" value=\"" + value + "\" data-name=\"value\" data-path=\"groupFields\">\n        ";
            })
                .join('');
            listItems += listItemTemplate(context);
            if (isRearrange !== false) {
                rearrange = "<div class=\"clearfix list-rearrange-btn\">\n          <span class=\"input-group\">" + listActionsBtn(name) + "</span>\n        </div>";
            }
        }
        else {
            listItems = rows
                .map(function (obj) {
                var value = obj.value;
                return "<li>" + value + "</li>";
            })
                .join('');
        }
        var ret = "\n    <ul id=\"ez-js-list-" + name + "\" class=\"list-unstyled unstyled-input-list\" data-container=\"groupfield\">\n      " + listItems + "\n    </ul>\n    " + rearrange;
        return ret;
    };
    var listItemTemplate = function (context) {
        var mode = context.mode, type = context.type, _a = context.value, value = _a === void 0 ? '' : _a, _b = context.cls, cls = _b === void 0 ? '' : _b;
        var listItem = '';
        if (type !== 'new') {
            listItem = "<i class=\"fa fa-pencil-square\"></i>" + (type === 'remove' ? "" + value : '');
        }
        if (type !== 'remove') {
            listItem = "<span class=\"input-group\">\n        <input class=\"form-control " + cls + "\" type=\"text\" value=\"" + value + "\" data-name=\"value\" data-path=\"groupFields\" />\n        <span class=\"input-group-btn\">\n          <button class=\"btn btn-default\" type=\"button\" data-mode=\"" + mode + "\" data-btn=\"add\" disabled><i class=\"fa fa-plus\"></i></button>\n          <button class=\"btn btn-default\" type=\"button\" data-mode=\"" + mode + "\" data-btn=\"remove\"><i class=\"fa fa-minus\"></i></button>\n        </span>\n      </span>";
        }
        var ret = "<li class=\"input-list input-list-" + type + " clearfix\" data-row-type=\"" + type + "\" data-row=\"groupFields\">" + listItem + "</li>";
        return ret;
    };
    function headingActionsBtn(name) {
        return "<button\n      id=\"ez-js-group-field-rearrange-" + name + "\"\n      data-btn=\"rearrange\"\n      class=\"btn btn-default\"\n      type=\"button\"><i class=\"fa fa-arrows-v\"></i></button>\n      <button\n      id=\"ez-js-group-field-rearrange-done-" + name + "\"\n      data-btn=\"rearrangeDone\"\n      class=\"btn btn-default\"\n      type=\"button\"><i class=\"fa fa-check\"></i></button>";
    }
    function listActionsBtn(name) {
        return "<button\n      id=\"ez-js-list-field-rearrange-" + name + "\"\n      data-btn=\"rearrange\"\n      class=\"btn btn-default btn-sm\"\n      type=\"button\"><i class=\"fa fa-arrows-v\"></i> Rearrange</button>\n      <button\n      id=\"ez-js-list-field-rearrange-done-" + name + "\"\n      data-btn=\"rearrangeDone\"\n      class=\"btn btn-default btn-sm\"\n      type=\"button\"><i class=\"fa fa-check\"></i> Done</button>";
    }
    /**
     *
     * @param context
     */
    var groupTemplate = function (context) {
        var e_1, _a, e_2, _b;
        var editable = context.editable, name = context.name, label = context.label, rows = context.rows, rearrange = context.rearrange, isAddAndRemove = context.isAddAndRemove;
        var rowsItems = '';
        if (editable) {
            try {
                for (var rows_1 = __values(rows), rows_1_1 = rows_1.next(); !rows_1_1.done; rows_1_1 = rows_1.next()) {
                    var row = rows_1_1.value;
                    rowsItems += groupItemTemplate(row, isAddAndRemove);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (rows_1_1 && !rows_1_1.done && (_a = rows_1.return)) _a.call(rows_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        else {
            try {
                for (var rows_2 = __values(rows), rows_2_1 = rows_2.next(); !rows_2_1.done; rows_2_1 = rows_2.next()) {
                    var row = rows_2_1.value;
                    rowsItems += "<tr>" + row
                        .map(function (obj) { return "<td>" + obj.value + "</td>"; })
                        .join('') + "</tr>";
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (rows_2_1 && !rows_2_1.done && (_b = rows_2.return)) _b.call(rows_2);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        var cls = "";
        var actionTh = "";
        if (editable && rearrange !== false) {
            actionTh = "<th width=\"90\" class=\"action-btns-th\">\n        " + headingActionsBtn(name) + "\n      </th>";
        }
        else if (isAddAndRemove !== false) {
            actionTh = '<th></th>';
        }
        if (isAddAndRemove === false) {
            cls = "group-input-no-action";
        }
        var headingTh = label
            .map(function (obj) { return "<th data-column=\"" + obj.name + "\">" + obj.label + "</th>"; })
            .join('');
        var ret = "<table id=\"ez-js-group-field-table-" + name + "\" class=\"" + cls + " table group-input-items-list\" data-container=\"groupfield\">\n      <thead>\n        <tr class=\"active\">\n          " + headingTh + "\n          " + actionTh + "\n        </tr>\n      </thead>\n      <tbody> " + rowsItems + " </tbody>\n    </table>";
        return ret;
    };
    /**
     *
     * @param context
     */
    var groupItemTemplate = function (context, isAddAndRemove) {
        var tdsArray = [];
        var actionTd = "";
        if (isAddAndRemove !== false) {
            actionTd = "<td>\n        <button class=\"btn btn-default\" type=\"button\" data-btn=\"add\" disabled><i class=\"fa fa-plus\"></i></button>\n        <button class=\"btn btn-default\" type=\"button\" data-btn=\"remove\"><i class=\"fa fa-minus\"></i></button>\n        <button class=\"btn btn-default\" type=\"button\" data-btn=\"move\" disabled><i class=\"fa fa-align-justify\"></i></button>\n      </td>";
        }
        context.forEach(function (_a) {
            var fields = _a.fields, edittype = _a.edittype, name = _a.name;
            tdsArray.push("<td class=\"form-group-fields\" data-row=\"input\" data-column=\"" + name + "\" " + edittype + ">\n        " + fields + "\n      </td>");
        });
        var ret = "<tr class=\"input-list input-list-group\" data-row=\"groupFields\" data-list-count=\"\">\n      " + tdsArray.join('') + "\n      " + actionTd + "\n    </tr>";
        return ret;
    };
    var templates;
    (function (templates) {
        templates.inputList = {
            listTemplate: listTemplate,
            listItemTemplate: listItemTemplate,
            groupTemplate: groupTemplate,
            groupItemTemplate: groupItemTemplate
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
